import styled from 'styled-components';
import space from '../utils/style/space';
import { fontSize } from '../utils/style/font';
import color from '../utils/style/color';

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${space.m}px;

  @media screen and (max-width: 576px) {
    gap: ${space.xxxs}px;
  }
`;

export const Paragraph = styled.p`
  font-size: ${fontSize.l}px;
  line-height: 1.5;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: ${space.m}px;
`;

export const Button = styled.button`
  width: 100%;
  height: 54px;
  border-radius: 2px;
  box-shadow: 0 0 2px 0 rgba(204, 204, 204, 0.5);
  background-color: ${color.red.brand};
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    background-color: ${color.gray.bright};
    cursor: not-allowed;
  }
`;
